// Resumo da semana (0.17.0): os últimos 7 dias e o que pede atenção, para
// ler no app ou mandar pelo WhatsApp (Relatórios → Resumo da semana; às
// segundas, também no Início).
import { acertos, dadosDosRelatorios, manutencao } from '../dados.js';
import { h, icone, trocar } from '../lib/dom.js';
import { mensagemDeErro } from '../lib/erros.js';
import { data, dinheiro, numeroBR, plural } from '../lib/formato.js';
import { atencaoDaEmpresa, pedeAtencao, resumoDaSemana, textoDoResumo, variacao } from '../lib/resumo.js';
import { hojeDaEmpresa, sessao } from '../sessao.js';
import { casca } from '../ui/casca.js';
import { avisar, carregando, faixa, secao } from '../ui/componentes.js';

// Tudo o que o resumo precisa, lido na hora.
export async function dadosDoResumo() {
  const hoje = hojeDaEmpresa();
  const [tabelas, listaAcertos, itens] = await Promise.all([dadosDosRelatorios(), acertos.listar(), manutencao.listar()]);
  const todas = { ...tabelas, acertos: listaAcertos, itens };
  return { r: resumoDaSemana(todas, { hoje }), atencao: atencaoDaEmpresa(todas, { hoje }) };
}

const comVariacao = (agora, antes) => {
  const v = variacao(agora, antes);
  return v && v !== 'igual' ? h('span', { class: 'pequeno' }, ` ${v}`) : null;
};

export function telaResumoDaSemana() {
  const corpo = h('div', { class: 'secao' }, carregando());
  (async () => {
    const { r, atencao } = await dadosDoResumo();
    const e = sessao.empresa;
    const texto = textoDoResumo(r, atencao, { empresa: e?.nome_fantasia || e?.nome || 'HSA Frota' });
    const linha = (rotulo, valor, extra = null) => [h('dt', null, rotulo), h('dd', null, valor, extra)];
    const pede = pedeAtencao(atencao);
    trocar(corpo,
      h('p', { class: 'pequeno' }, `De ${data(r.de)} a ${data(r.ate)} (os últimos 7 dias). A porcentagem compara com os 7 dias antes.`),
      secao('Na semana', h('dl', { class: 'linha-dados resumo' },
        linha('Cargas', String(r.cargas)),
        linha('Fretes', dinheiro(r.fretes), comVariacao(r.fretes, r.anterior.fretes)),
        linha('Recebido dos clientes', dinheiro(r.recebido)),
        linha('Despesas', dinheiro(r.despesas), comVariacao(r.despesas, r.anterior.despesas)),
        r.diesel > 0 && linha('Diesel', `${dinheiro(r.diesel)}${r.litros > 0 ? ` · ${numeroBR(Math.round(r.litros))} L` : ''}`),
        r.manutencao > 0 && linha('Manutenção', dinheiro(r.manutencao)),
        r.outras > 0 && linha('Outras despesas', dinheiro(r.outras)),
        r.vales > 0 && linha('Vales aos motoristas', dinheiro(r.vales)))),
      secao('Pede atenção', pede.length === 0
        ? h('p', { class: 'pequeno' }, 'Nada atrasado, vencido ou fora do normal. Boa semana!')
        : h('ul', { class: 'lista-simples' }, pede.map((p) => h('li', null, p)))),
      h('div', { class: 'acoes' },
        h('a', { class: 'botao cheio', href: `https://wa.me/?text=${encodeURIComponent(texto)}`, target: '_blank', rel: 'noopener' },
          icone('telefone', { tamanho: 20 }), ' Mandar pelo WhatsApp'),
        h('button', {
          class: 'botao cheio secundario',
          type: 'button',
          onClick: async () => {
            try {
              await navigator.clipboard.writeText(texto);
              avisar('Resumo copiado.');
            } catch {
              avisar('Não deu para copiar aqui. Use "Mandar pelo WhatsApp".', 'erro');
            }
          },
        }, 'Copiar o resumo')));
  })().catch((erro) => {
    console.error(erro);
    trocar(corpo, faixa(mensagemDeErro(erro), 'perigo'));
  });
  return casca({ titulo: 'Resumo da semana', voltar: '/relatorios', conteudo: [corpo] });
}

// O cartão do Início, às segundas: a semana que passou em uma linha.
export async function cartaoDoResumo(hoje = hojeDaEmpresa()) {
  const [a, m, d] = hoje.split('-').map(Number);
  if (new Date(Date.UTC(a, m - 1, d)).getUTCDay() !== 1) return null;
  const { r } = await dadosDoResumo();
  if (r.cargas === 0 && r.despesas === 0) return null;
  return h('a', { class: 'cartao a-resumo', href: '#/relatorios/semana' },
    icone('grafico', { tamanho: 28 }),
    h('span', { class: 'cartao-corpo' },
      h('span', { class: 'cartao-titulo' }, 'Resumo da semana'),
      h('span', { class: 'cartao-linha' }, `${plural(r.cargas, 'carga')}: ${dinheiro(r.fretes)} em fretes · despesas: ${dinheiro(r.despesas)}`)),
    icone('seta', { classe: 'icone seta' }));
}
